import React from 'react';
import Modal, { IModalChildProps } from '../../../common/modal';
import { FormattedMessage } from 'react-intl';

const ConfirmBilToModal: React.FC<IModalChildProps> = ({
    onAccept,
    onClose,
}) => {
    return (
        <Modal>
            <>
                <div className="modal-header">
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={onClose}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 className="modal-title">
                        <FormattedMessage
                            id="Are_You_Sure_You_Want_To_Set_A_Bill_To_Shipping_Default"
                            defaultMessage="Are you sure you want to set a Bill To shipping default?"
                        />
                    </h4>
                </div>
                <div className="modal-body">
                    <FormattedMessage
                        id="Specifying_A_Shipping_Default_At_The_Bill_To_Will_Override"
                        defaultMessage="Specifying a shipping default at the Bill To will override the Ship To defaults!"
                    />
                </div>
                <div className="modal-footer">
                    <button className="btn btn-primary" onClick={onAccept}>
                        <FormattedMessage
                            id="Yes_I_Am_Sure"
                            defaultMessage="Yes I'm sure"
                        />
                    </button>
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={onClose}
                    >
                        <FormattedMessage id="Cancel" />
                    </button>
                </div>
            </>
        </Modal>
    );
};

export default ConfirmBilToModal;
